import { ELimitType, LIMITS } from "@/backend/domains/organization/domain/Limit";

import { AppError } from "./AppError";

//

export type PermissionErrorAction = "UPGRADE_SUBSCRIPTION" | "UP_ROLE" | "LIMIT";

interface PermissionErrorData {
  action: PermissionErrorAction;
}

type ToAbleData<T> = Omit<T, keyof PermissionErrorData>;

//

export class PermissionError<TData = unknown> extends AppError<
  PermissionErrorData & ToAbleData<TData>
> {
  constructor(message: string, data: PermissionErrorData & TData) {
    super(message, {
      isOperational: true,
      statusCode: 400,
      data,
    });
    this.name = "PermissionError";
    Error.captureStackTrace(this, PermissionError);
  }
}

//

export class LimitExceededError extends PermissionError<{ limitType: ELimitType }> {
  constructor(limitType: ELimitType) {
    const localedLimitType = LIMITS[limitType].title;
    super(`Лимит ${localedLimitType.toLowerCase()} исчерпан. Повышение тарифа откроет доступ.`, {
      limitType,
      action: "LIMIT",
    });
    this.name = "LimitExceededError";
    Error.captureStackTrace(this, LimitExceededError);
  }
}

//

export class SubscriptionAccessError extends PermissionError {
  constructor() {
    super("Функция не доступна. Проверьте подписку или обновите ее.", {
      action: "UPGRADE_SUBSCRIPTION",
    });
    this.name = "SubscriptionAccessError";
    Error.captureStackTrace(this, SubscriptionAccessError);
  }
}

//

export class SubscriptionActionAccessError extends PermissionError {
  constructor() {
    super("Недоступно на вашем тарифе. Повышение тарифа откроет доступ.", {
      action: "UPGRADE_SUBSCRIPTION",
    });
    this.name = "SubscriptionActionAccessError";
    Error.captureStackTrace(this, SubscriptionActionAccessError);
  }
}

//

export class RoleAccessError extends PermissionError {
  constructor() {
    super("Недостаточно прав. Обратитесь к администратору организации для получения доступа.", {
      action: "UP_ROLE",
    });
    this.name = "RoleAccessError";
    Error.captureStackTrace(this, RoleAccessError);
  }
}
